// Staff administration's nav. Composed by the ADMIN portal beside lib, cms and fin.
//
// `core:staff` gates the entry, so an operator without it never sees the item —
// and because every other module's items carry their own perms, a person who
// holds ONLY core:staff sees this section and nothing else. That falls out of
// buildNav's existing filter; there is no special case anywhere.
import { ShieldCheck, UserPlus, Users } from "lucide-solid";
import type { ModuleManifest } from "@erp/auth-kit/nav";

export const authAdminNav: ModuleManifest = {
  id: "people",
  // The SURFACE is "people"; the install module that owns it is auth — a
  // platform module, so this manifest survives every enabled set (§13).
  module: "auth",
  label: "People",
  icon: Users,
  // The REGISTER is the area's landing page now, not the invite form. A section
  // whose front door is a creation form asks a question before showing anyone
  // what is already there.
  to: "/staff",
  sections: [
    {
      id: "people-staff",
      label: "Staff",
      items: [
        { id: "people-staff-list", label: "Staff", to: "/staff", icon: Users, perm: "core:staff" },
        { id: "people-roles", label: "Roles", to: "/staff/roles", icon: ShieldCheck, perm: "core:staff" },
        { id: "people-invite", label: "Invite a colleague", to: "/staff/invite", icon: UserPlus, perm: "core:staff" },
      ],
    },
  ],
};
